import React, { useContext, useState } from 'react';
import { infoUser, isTokenValid } from '../utils/auth';
import Header from './Header';

import AppContext from '../Context/AppContext';
import Loader from '../components/Loader';
import logo from "../assets/logos/logo-fin.png";
import SideRight from './SideRight';
import BottomNav from './BottomNav';
import { SocketProvider } from '../Context/SocketContext';
import { SupportProvider } from '../Context/SupportContext';
const Template = ({ children }) => {

    const { loadInit } = useContext(AppContext)
    const [menuOpen, setMenuOpen] = useState(false)
    const isVlaidToken = isTokenValid()

    if (!isVlaidToken) {
        window.location.href = "/login";
        return;
    }
    if (loadInit) {
        return <div className='h100vh w100 df fdc aic jcc'>
            <img src={logo} style={{ height: "40px", width: "40px" }} className='mb3'></img>
            <Loader />
        </div>
    }
    const user = infoUser()



    return (
        <SocketProvider>
            <SupportProvider>
            <div className='mainer wrapper df fdc'>
                <Header onToggleMenu={() => setMenuOpen(v => !v)} />
                <div className='container-all'>
                    <SideRight open={menuOpen} onClose={() => setMenuOpen(false)} />
                    {children}
                </div>
                <BottomNav onMenu={() => setMenuOpen(true)} />
            </div>
            </SupportProvider>
        </SocketProvider>
    );
};

export default Template;